import { HttpClient } from '@angular/common/http';
import { Injectable, NgZone } from '@angular/core';
import { AlertController, ToastController, LoadingController, PopoverController, Platform } from '@ionic/angular';
import { SelectItemListaComponent } from 'src/app/components/compartidos/select-item-lista/select-item-lista.component';
import { OpNotificacionesWMS } from 'src/app/interfaces/Notificaciones/iop-notificaciones-wms';

/*
  Generated class for the MensajesProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable({
  providedIn: 'root'
})
export class MensajesProvider {
  private blnEsHadHeld = false;

  constructor(
    public http: HttpClient,
    private alertController: AlertController,
    private toastController: ToastController,
    private loadingController: LoadingController,
    private zone: NgZone,
    private popoverController: PopoverController,
    private platform: Platform,
  ) {
    // Revisamos el tipo de dispositivo para validar que configuraciones necesitamos habilitar po default
    // Si no es core es un dispositivo movil
    if (this.platform.is('cordova')) {
      this.blnEsHadHeld = true;
    } else {
      // Es un navegador
      this.blnEsHadHeld = false;
    }
  }


  async alertaInformativa(message: string) {
    const alert = await this.alertController.create({
      message,
      buttons: ['OK']
    });

    await alert.present();
  }

  async alertaInformativaPromise(
    header: string, message: string,
    intTiempoOcionDefault: number = 0, cssClass: string = ''
  ): Promise<boolean> {
    return new Promise<boolean>(async resolve => {
      let saveInterval: number;
      const alert = await this.alertController.create({
        header,
        subHeader: ((intTiempoOcionDefault > 0) ? (`Opción por default en ${intTiempoOcionDefault}`) : ''),
        message,
        cssClass,
        buttons: [
          {
            text: 'Aceptar',
            handler: () => {
              // console.log('Aceptar');
              window.clearInterval(saveInterval);
              resolve(true);
            }
          }
        ]
      });

      if (intTiempoOcionDefault > 0) {
        saveInterval = window.setInterval(() => {
          intTiempoOcionDefault--;
          this.zone.run(() => {
            alert.subHeader = `Opción por default en ${intTiempoOcionDefault}`;
          });
          // console.log('intContadorParaDefault--', intTiempoOcionDefault);
          if (intTiempoOcionDefault === 0) {
            alert.dismiss();
            resolve(true);
            window.clearInterval(saveInterval);
          }
        }, 1000);
      }

      await alert.present();
    });
  }

  async alertaInformativaNoDismiss(message: string) {
    return await this.alertController.create({
      message,
      backdropDismiss: false
    });

    // await alert.present();
  }

  async presentToast(message: string) {
    const toast = await this.toastController.create({
      message,
      position: 'top',
      duration: 2000
    });
    return toast.present();
  }

  async presentToastTimeEditable(message: string,duration:number) {
    const toast = await this.toastController.create({
      message,
      position: "top",
      duration: duration
    });
    return toast.present();
  }

  async presentToastCustom(toastOptions: any) {
    const toast = await this.toastController.create(toastOptions);
    return toast.present();
  }

  async presentLoadingWithOptions(strMensaje: string) {
    return await this.loadingController.create({
      duration: 10000,
      message: strMensaje,
      spinner: 'dots',
      backdropDismiss: true,
    });
  }

  async presentLoadingWithOptionsInfinite(strMensaje: string) {
    return await this.loadingController.create({
      message: strMensaje,
      spinner: 'dots',
      backdropDismiss: true,
    });
  }

  async presentAlertConfirm(header: string, message: string, intTiempoOcionDefault: number = 0, cssClass: string = ''): Promise<boolean> {
    return new Promise<boolean>(async resolve => {
      let saveInterval: number;
      const alert = await this.alertController.create({
        header,
        subHeader: ((intTiempoOcionDefault > 0) ? (`Opción por default en ${intTiempoOcionDefault}`) : ''),
        message,
        cssClass,
        buttons: [
          {
            text: 'Aceptar',
            handler: () => {
              // console.log('Aceptar');
              window.clearInterval(saveInterval);
              resolve(true);
            }
          },
          {
            text: 'Cancelar',
            role: 'cancel',
            cssClass: 'secondary',
            handler: (blah) => {
              // console.log('Cancelar');
              window.clearInterval(saveInterval);
              resolve(false);
            }
          }
        ]
      });

      if (intTiempoOcionDefault > 0) {
        saveInterval = window.setInterval(() => {
          intTiempoOcionDefault--;
          this.zone.run(() => {
            alert.subHeader = `Opción por default en ${intTiempoOcionDefault}`;
          });
          // console.log('intContadorParaDefault--', intTiempoOcionDefault);
          if (intTiempoOcionDefault === 0) {
            alert.dismiss();
            resolve(true);
            window.clearInterval(saveInterval);
          }
        }, 1000);
      }

      await alert.present();
    });
  }

  async presentAlertEmail(header: string): Promise<string> {
    return new Promise<string>(async resolve => {
      const alert = await this.alertController.create({
        header,
        inputs: [
          {
            name: 'correo',
            type: 'email',
            placeholder: 'e-mail'
          },
        ],
        buttons: [

          {
            text: 'Aceptar',
            handler: async (data) => {
              // console.log('Aceptar', data);
              if (data.correo && data.correo !== '' && this.validateEmail(data.correo)) {
                resolve(data.correo);
              } else {
                const toast = await this.toastController.create({
                  message: `Correo invalido ${data.correo}`,
                  position: 'top',
                  duration: 2000
                });
                toast.present();
                return false;
                // }
              }
            }
          },
          {
            text: 'Cancelar',
            role: 'cancel',
            cssClass: 'secondary',
            handler: (blah) => {
              // console.log('Cancelar', blah);
              resolve(undefined);
            }
          }
        ]

      });
      await alert.present();
    });
  }

  private validateEmail(email: string) {
    // eslint-disable-next-line max-len
    const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
  }

  async presentAlertPeriodoRadios<T>(
    header: string,
    lstFiltrosPeriodos: any[],
    intIndex: string,
    valueExpr: string,
    dataExpr: string,
    intTiempoOcionDefault: number = 0
  ): Promise<T> {
    return new Promise<T>(async resolve => {
      let saveInterval: number;

      const input: any[] = [];

      lstFiltrosPeriodos.forEach((element: any) => {
        input.push({
          type: 'radio',
          label: `${element[dataExpr]}`,
          value: element[valueExpr].toString(),
          checked: element[valueExpr].toString() === intIndex.toString()
        });
      });

      const alert = await this.alertController.create({
        header: `${header}`,
        subHeader: ((intTiempoOcionDefault > 0) ? (`Opción por default en ${intTiempoOcionDefault}`) : ''),
        cssClass: 'fullscreen',
        inputs: input,
        buttons: [
          {
            text: 'Aceptar',
            handler: data => {
              window.clearInterval(saveInterval);
              if (data) {
                // console.log('Aceptar', { data });
                // resolve(lstFiltrosPeriodos.find(x => x[valueExpr].toString() === data));
              } else {
                resolve(undefined);
              }
            }
          }
        ]
      });

      alert.onDidDismiss().then((data) => {
        // console.log('onDidDismiss');
        // console.log({ data });
        if (data.data !== undefined) {
          resolve(lstFiltrosPeriodos.find(x => x[valueExpr].toString() === data.data.values));
        } else {
          resolve(undefined);
        }

      });

      await alert.present();

      if (intTiempoOcionDefault > 0) {
        saveInterval = window.setInterval(() => {
          intTiempoOcionDefault--;
          this.zone.run(() => {
            alert.subHeader = `Opción por default en ${intTiempoOcionDefault}`;
          });
          // console.log('intContadorParaDefault--', intTiempoOcionDefault);
          if (intTiempoOcionDefault === 0) {
            alert.dismiss({ values: intIndex });

            window.clearInterval(saveInterval);
          }
        }, 1000);
      }
    });
  }

  async presentAlertPass(): Promise<string> {
    return new Promise<string>(async resolve => {

      const alert = await this.alertController.create({
        header: 'Autorización',
        message: 'Indique el acceso del administrador',
        inputs: [
          {
            name: 'Acceso',
            placeholder: 'Acceso',
            type: 'password',
            // value: (blnAutoFill ? strPass : '')
          },
        ],
        buttons: [
          {
            text: 'Aceptar',
            handler: (data) => {
              if (data.Acceso && data.Acceso !== '') {
                // if (data.Acceso === strPass) {
                  resolve(data.Acceso);
                // } else {
                  // this.presentToast('Acceso incorrecto');
                  // resolve(false);
                // }
              } else {
                resolve(undefined);
              }
            }
          },
          {
            text: 'Cancelar',
            role: 'cancel',
            cssClass: 'secondary',
            handler: (blah) => {
              // console.log('Cancelar', blah);
              resolve(undefined);
            }
          }
        ]

      });
      await alert.present();
    });
  }

  async presentAlertNumber(header: string, message: string, minValue: number, maxValue?: number,Default:number = null): Promise<number> {
    return new Promise<number>(async resolve => {

      const alert = await this.alertController.create({
        header,
        message,
        inputs: [
          {
            name: 'cantidad',
            placeholder: 'Cantidad',
            type: 'number',
            value:Default
          },
        ],
        buttons: [
          {
            text: 'Aceptar',
            handler: (data) => {
              if (data && data.cantidad) {
                const intCantidad = Number(data.cantidad);
                if (intCantidad >= minValue) {
                  if (maxValue === undefined) {
                    resolve(intCantidad);
                  } else {
                    if (intCantidad <= maxValue) {
                      resolve(intCantidad);
                    } else {
                      this.presentToast(`La cantidad no puede ser mayor a ${maxValue} `);
                      return false;
                    }
                  }
                } else {
                  this.presentToast(`La cantidad no puede ser menor a ${minValue} `);
                  return false;
                }
              } else {
                return false;
              }
            }

          },
          {
            text: 'Cancelar',
            role: 'cancel',
            cssClass: 'secondary',
            handler: (blah) => {
              // console.log('Cancelar', blah);
              resolve(0);
            }
          }
        ]

      });
      await alert.present();
    });
  }

  async presentAlertInputText(header: string, message: string,Default:string = null): Promise<string> {
    return new Promise<string>(async resolve => {

      const alert = await this.alertController.create({
        header,
        message,
        inputs: [
          {
            name: 'txtval',
            placeholder: 'txtval',
            type: 'text',
            value:Default
          },
        ],
        buttons: [
          {
            text: 'Aceptar',
            handler: (data) => {
              if (data && data.txtval) {
                
                resolve(data.txtval);
              }
              else{
                return false;
              }
            }

          },
          {
            text: 'Cancelar',
            role: 'cancel',
            cssClass: 'secondary',
            handler: (blah) => {
              // console.log('Cancelar', blah);
              resolve(null);
            }
          }
        ]

      });
      await alert.present();
    });
  }

  async presentAlertText(header: string, message: string, name: string, placeholder: string): Promise<string> {
    return new Promise<string>(async resolve => {

      const alert = await this.alertController.create({
        header,
        message,
        inputs: [
          {
            name,
            placeholder,
          },
        ],
        buttons: [
          {
            text: 'Cancelar',
            role: 'cancel',
            cssClass: 'secondary',
            handler: (blah) => {
              // console.log('Cancelar', blah);
              resolve(undefined);
            }
          },
          {
            text: 'Aceptar',
            handler: (data) => {
              if (data[name] && data[name] !== '') {
                resolve(data[name].toUpperCase().trim());
              } else {
                return false;
              }
            }
          }
        ]

      });
      await alert.present();
    });
  }

  public tiempoDesdeFecha(dteFechaAnterior: Date, dteFechaPosterior: Date): string {
    let strTiempoTranscurrido = '';
    if (dteFechaAnterior && dteFechaPosterior) {

      const milliseconds = (new Date(dteFechaPosterior).getTime() - new Date(dteFechaAnterior).getTime());

      let day, hour, minute, seconds;
      seconds = Math.floor(milliseconds / 1000);
      minute = Math.floor(seconds / 60);
      seconds = seconds % 60;
      hour = Math.floor(minute / 60);
      minute = minute % 60;
      day = Math.floor(hour / 24);
      hour = hour % 24;

      strTiempoTranscurrido = `
      ${day} ${((day > 1) ? ' Dias ' : ' Dia ')}
      ${hour} ${((hour > 1) ? ' Horas ' : ' Hora ')}
      ${minute} ${((minute > 1) ? ' Minutos ' : ' Minuto ')}
      ${seconds} ${((seconds > 1) ? ' Segundos ' : ' Segundo ')}`;

    }

    return strTiempoTranscurrido;
  }

  async presentPopover<T>(
    titulo: string,
    catalogo: any[],
    descripcion: string,
    nombre: string,
    color: string,
    event: Event,
  ): Promise<T> {
    return new Promise<T>(async resolve => {
      // Popover con las cuentas a las cuales tiene acceso el usuario
      const ppAlmacen = await this.popoverController.create({
        component: SelectItemListaComponent,
        showBackdrop: true,
        backdropDismiss: true,
        translucent: true,
        animated: true,
        mode: 'ios',
        event,
        componentProps: {
          catalogo,
          titulo,
          nombre,
          descripcion,
          color
        },
        cssClass: 'pop-over-style'
      });

      await ppAlmacen.present();

      const { data } = await ppAlmacen.onWillDismiss();

      // console.log({ data });
      if (!!data) {
        resolve(data);
      }

    });
  }

  async showNotificacionesWMSToast(itmMensaje: OpNotificacionesWMS): Promise<HTMLIonToastElement> {

    const lstBotones: any[] = [];
    if (this.blnEsHadHeld || !!itmMensaje.blnPuedeCerrarse) {
      lstBotones.push(
        {
          side: 'start',
          icon: 'close-circle-outline',
          handler: () => {
            console.log('Hola clicked');
          }
        }
      );
    }
    if (!!itmMensaje.strAccion) {
      lstBotones.push(
        {
          side: 'end',
          icon: 'arrow-forward',
          text: 'Continuar',
          handler: () => {
            console.log('Continuar clicked');
          }
        }
      );
    }

    return await this.toastController.create({
      header: itmMensaje.strCabecero,
      message: itmMensaje.strMensaje,
      position: itmMensaje.strPosicion || 'top',// "bottom" | "middle" | "top"
      duration: (itmMensaje.intMinutos > 0) ? (itmMensaje.intMinutos * 60000) : 0,
      color: itmMensaje.strColor || 'primary',
      // "primary", "secondary", "tertiary", "success", "warning", "danger", "light", "medium", "dark"
      buttons: lstBotones
    });
  }

  public async validaCantidadAcceso<T>(
    lstCatalogo: any[], strCatalogo: string, nombre: string, descripcion: string, color: string
  ): Promise<T> {
    return new Promise<T>(async resolve => {
      if (!!!lstCatalogo) {
        resolve(undefined);
      }
      else if (lstCatalogo.length === 1) {
        await this.presentToastCustom({
          message: `${strCatalogo}: ${(lstCatalogo[0])[nombre]}`,
          position: 'bottom', duration: 1500, buttons: [
            { icon: 'close-circle-outline', side: 'start', cssClass: 'warning' }
          ]
        });
        resolve(lstCatalogo[0]);
      } else {
        const itmSeleccion = await this.showPopoverCatalog<T>(lstCatalogo, strCatalogo, nombre, descripcion, color);
        if (itmSeleccion) {
          resolve(itmSeleccion);
        } else {
          resolve(undefined);
        }
      }
    });
  }

  async showPopoverCatalog<T>(
    catalogo: any[], titulo: string, nombre: string, descripcion: string, color: string
  ): Promise<T> {
    return new Promise<T>(async resolve => {

      // Popover
      const ppCuentas = await this.popoverController.create({
        component: SelectItemListaComponent,
        showBackdrop: true,
        backdropDismiss: true,
        translucent: true,
        animated: true,
        mode: 'ios',
        // event,
        componentProps: {
          catalogo,
          titulo,
          nombre,
          descripcion,
          color,
        },
        cssClass: 'pop-over-style'

      });

      await ppCuentas.present();

      const { data } = await ppCuentas.onWillDismiss();

      if (!!data) {
        resolve(data);
      } else {
        this.presentToastCustom({
          message: 'Debe elegir una opción', position: 'bottom', duration: 1500, buttons: [
            {
              icon: 'close-circle-outline',
              side: 'start',
              cssClass: 'warning'
            }
          ]
        });
        resolve(undefined);
      }
    });
  }

  delay(milliseconds: number, count: number): Promise<number> {
    return new Promise<number>(resolve => {
      setTimeout(() => {
        resolve(count);
      }, milliseconds);
    });
  }

}
